<!--Buttons-->
<div class="flex justify-end align-center mt2 mb2">
  <ng-content select="[buttons]"></ng-content>
</div>

<div class="header-container">
  <div class="header-spacer">
    <div class="clearfix">
      <div class="flex flex-row items-baseline mt2 w-100">
        <div class="flex flex-none items-center">
          <div class="flex items-center mr3">
            <mat-form-field class="search-input-field" data-qa="qa-search-transaction">
              <mat-label>Search {{TabLabel.Transactions}}</mat-label>
              <input matInput type="text"
                     [formControl]="claimsSearchNameFormControl"
                     (input)="onInputChangedSearchTransactions($event)">
            </mat-form-field>

            <div class="search-actions">
              @if (claimsSearchNameFormControl.value) {
                <mat-icon class="info-icon hand-cursor"
                          (click)="clearSearchTransactionsFilter()">
                  close
                </mat-icon>
              }
              <mat-icon class="info-icon hand-cursor"
                        data-qa="qa-tune-search-transaction"
                        [matBadge]="selectedSearchCriteriaCount"
                        matBadgeDescription="selected search fields"
                        [matBadgeHidden]="selectedSearchCriteriaCount === 0"
                        (click)="onClickShowSearchCriteriaDialog($event)">
                tune
              </mat-icon>
              @if (upfrontRejectedClaims) {
                <mat-icon class="info-icon hand-cursor"
                          data-qa="qa-upfront-rejections-claims"
                          matTooltip="Upfront Rejected Claims"
                          [matBadge]="upfrontRejectedClaims" matBadgeColor="warn"
                          [matBadgeHidden]="upfrontRejectedClaims === 0"
                          (click)="onClickShowUpfrontRejectedClaimDialog($event)">
                  notifications_active
                </mat-icon>
              }
            </div>
          </div>

          <div class="mr3" style="width: 250px;">
            <app-element-multi-select qaAttr="qa-filters"
                                      displayLabel="Selected Filters"
                                      [cssClasses]="['w-95']"
                                      [selectedValues]="selectedFilters"
                                      [defaultValues]="defaultFiltersValues"
                                      [options]="filterLabels"
                                      [disabledOptions]="temporarilyDisabledFilters"
                                      [disabledOptionTooltip]="temporarilyDisabledFilterTooltip"
                                      (selectedValuesChange)="onSelectedFiltersSelectionChanged($event)">
            </app-element-multi-select>
          </div>

        </div>

        <div class="claims-filter-bar flex-auto">

          @if (selectedFilters[filters.SubmittedBy]) {
            <app-element-select class="claims-filter-item"
                                displayLabel='Submitted By'
                                qaAttr="qa-submittedBy"
                                [defaultValue]="createdBy"
                                [options]="createdByList"
                                (selectionChanged)="onCreatedBySelectionChanged($event)">
            </app-element-select>
          }

          @if (selectedFilters[filters.ProcessingClass]) {
            <app-element-select class="claims-filter-item" displayLabel='Processing Class'
                                qaAttr="qa-processingClass"
                                [disabled]="disabledProcessingClass"
                                [defaultValue]="processingClass"
                                [options]="processingClasses"
                                (selectionChanged)="processingClassSelected($event)">
            </app-element-select>
          }

          @if (selectedFilters[filters.SubClass]) {
            <span class="claims-filter-item" [matTooltip]="temporarilyDisabledFilterTooltip">
              <app-element-select displayLabel='Sub-Class'
                                  qaAttr="qa-subClass"
                                  [disabled]="isFilterTemporarilyDisabled(filters.SubClass)"
                                  [defaultValue]="processingSubClass"
                                  [options]="getSubClasses()"
                                  (selectionChanged)="onProcessingSubClassSelectionChanged($event)">
              </app-element-select>
            </span>
          }

          @if (selectedFilters[filters.TransactionType]) {
            <app-element-select class="claims-filter-item" displayLabel='Transaction Type'
                                [defaultValue]="claimType"
                                [options]="claimTypes"
                                (selectionChanged)="claimTypeSelected($event)">
            </app-element-select>
          }

          @if (selectedFilters[filters.AdjudicationStatus]) {
            <app-element-select class="claims-filter-item"
                                displayLabel='Adjudication Status'
                                qaAttr="qa-adjudicationStatus"
                                [defaultValue]="adjudicationStatus"
                                [options]="adjudicationStatuses"
                                (selectionChanged)="adjudicationStatusSelected($event)">
            </app-element-select>
          }

          @if (selectedFilters[filters.ProcessingStage]) {
            <app-element-select class="claims-filter-item" displayLabel='Processing Stage'
                                qaAttr="qa-processingStage"
                                [defaultValue]="processingStage"
                                [options]="processingStages"
                                (selectionChanged)="processingStageSelected($event)">
            </app-element-select>
          }

          @if (selectedFilters[filters.Product]) {
            <app-product-filter class="claims-filter-item"
                                [selectedProducts]="products"
                                [cssClasses]="['mr1']"
                                (productChanged)="onProductChanged($event)">
            </app-product-filter>
          }

          @if (selectedFilters[filters.FamilyOfBenefit]) {
            <span class="claims-filter-item">
              <app-element-select displayLabel='Benefit Family'
                                  qaAttr="qa-family-benefit"
                                  [disabled]="isFilterTemporarilyDisabled(filters.FamilyOfBenefit)"
                                  [defaultValue]="familyOfBenefit"
                                  [options]="familyOfBenefits"
                                  (selectionChanged)="familyOfBenefitSelected($event)">
              </app-element-select>
            </span>
          }

          @if (selectedFilters[filters.ChargeableCode]) {
            <form [formGroup]="parentForm" class="claims-filter-item" [matTooltip]="temporarilyDisabledFilterTooltip">
              <app-element-input
                label="Chargeable Code"
                placeholder="Search Code"
                formControlName="tariffCodeList"
                [disabled]="isFilterTemporarilyDisabled(filters.ChargeableCode)"
                [includeDebounceTime]="true"
                (valueChange)="onChargeableCodeChanged($event)">
              </app-element-input>
            </form>
          }

          @if (selectedFilters[filters.PracticeNumber]) {
            <form [formGroup]="parentForm" class="claims-filter-item">
              <app-element-input
                label="Practice Number"
                placeholder="Search Practice"
                formControlName="practiceNumber"
                [includeDebounceTime]="true"
                (valueChange)="onPracticeNumberChanged($event)">
              </app-element-input>
            </form>
          }

          @if (selectedFilters[filters.DateRange]) {
            <form [formGroup]="parentForm" class="claims-filter-item claims-date-range-filter">
              <app-element-date-range
                formControlName="dateRange"
                label="Date Range"
                (dateRangeChanged)="onDateRangeChanged($event)">
              </app-element-date-range>
            </form>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (transactionDataSource) {
  <div class="mat-elevation-z8 table-container">

  <table mat-table multiTemplateDataRows [dataSource]="transactionDataSource" matSort
         (matSortChange)="sortData($event)">

    <ng-container [matColumnDef]="tableColumns.Icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell class="font-small">

        <div class="icon-container">
          <mat-icon class="table-icon font-medium" matTooltip="VIEW Details"
                    (click)="viewClaimDetails($event, row.transactionId)">info
          </mat-icon>

          @if (allowView(row)) {
            <mat-icon  class="table-icon font-medium" matTooltip="VIEW Transaction"
                      (click)="onClickViewOrReviewClaim($event, row, true)">remove_red_eye
            </mat-icon>
          }

          @if (allowReview(row)) {
            <mat-icon class="table-icon font-medium" matTooltip="REVIEW Transaction"
                    (click)="onClickViewOrReviewClaim($event, row, false)">rate_review
            </mat-icon>
          }

          @if (allowWarning(row)){
            <mat-icon
                    class="table-icon font-medium"
                    style="color: red " (click)="onClickOpenErrorDialog(row)">
            warning
          </mat-icon>
          }
      </div>
      <div class="icon-container">
         <!-- Lock / Unlock buttons   -->
          @if(!isProviderPortal){
            @if (isAuthorisedToShowLockTransaction(row)) {
              <mat-icon class="table-icon font-medium"
                  matTooltip="LOCK Transaction"
                  (click)="onClickLockClaim($event, row)">lock
              </mat-icon>
            }

            @if (isAuthorisedToShowUnlockTransaction(row)) {
              <mat-icon class="table-icon font-medium"
                  [ngClass]="{'disabled-grey': !isAuthorisedToUnlockClaim()}"
                  [matTooltip]="!isAuthorisedToUnlockClaim() ? 'Only team leaders can unlock transactions' : 'UNLOCK Transaction'"
                  (click)="isAuthorisedToUnlockClaim() && onClickUnlockClaim($event, row)">lock_open
              </mat-icon>
            }
          }


          @if (allowReverse(row)) {
            <mat-icon  class="table-icon font-medium"
                  matTooltip="REVERSE accepted transaction"
                  (click)="reverseClaim($event, row)">undo
            </mat-icon>
          }
      </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.TransactionId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-5"> ID</th>
      <td *matCellDef="let row" mat-cell class="font-small"> {{row.transactionId}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.TransactionType">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Type</th>
      <td *matCellDef="let row" mat-cell class="font-small"> {{row.transactionType}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.EffectiveDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Effective Date</th>
      <td *matCellDef="let row" mat-cell class="font-small"> {{row[tableColumns.EffectiveDate] | date: dateFormat}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.PolicyNumber">
      <th *matHeaderCellDef mat-header-cell> Policy</th>
      <td *matCellDef="let row" mat-cell class="font-small"> {{row.policyNumber}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.ProductName">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Product Name</th>
      <td *matCellDef="let row" mat-cell class="font-small"> {{row?.productName}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.InsuredPersonName">
      <th *matHeaderCellDef mat-header-cell> Member</th>
      <td *matCellDef="let row" mat-cell class="font-small">
        <div class="member-cell">
          <span class="dep-badge">{{row.dependentNo || '00'}}</span>
          <span class="member-cell__body">
            <a (click)="openMemberDialog(row, $event)" class="member-link">
              {{row.insuredPersonName | slice : 0 : 40}}
            </a>
            <span class="member-relationship">{{getMemberRelationshipLabel(row)}}</span>
          </span>
        </div>
      </td>
    </ng-container>


    <ng-container [matColumnDef]="tableColumns.ProviderName">
      <th *matHeaderCellDef mat-header-cell> Provider</th>
      <td *matCellDef="let row" mat-cell class="font-small">
        {{row.providerNumber}}: {{row.providerName | slice : 0 : 40}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.PayTo">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Pay</th>
      <td *matCellDef="let row" mat-cell style="white-space: pre"
          [matTooltip]="(row.transactionType == ClaimType.CLAIM ? row.payTo : null)"> {{(row.transactionType == ClaimType.CLAIM ? ClmFunctions.getPayToAcronym(row.payTo) : null)}} </td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.BilledAmount">
      <th *matHeaderCellDef mat-header-cell class="w-5"> Billed</th>
      <td *matCellDef="let row" mat-cell class="font-small"
          style="white-space: pre"> {{ (row.amountBilled  ?? 0)| number:'1.2-2'}} </td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.ClaimedAmount">
      <th *matHeaderCellDef mat-header-cell class="w-5"> Claimed</th>
      <td *matCellDef="let row" mat-cell class="font-small"
          style="white-space: pre"> {{ (row.amountClaimed ?? 0) | number:'1.2-2'}} </td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.BenefitAmount">
      <th *matHeaderCellDef mat-header-cell> Benefit</th>
      <td *matCellDef="let row" mat-cell class="font-small"
          style="white-space: pre"> {{ (row.benefitAmount  ?? 0) | number:'1.2-2'}}</td>
   </ng-container>

    <ng-container [matColumnDef]="tableColumns.AssessingStatus">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Status</th>
      <td *matCellDef="let row" mat-cell>
        @if (row.assessingStatus) {
          <div class="flex justify-start">
            <greydom-status-indicator
              [fillColor]="getStatusColor(row.assessingStatus)"></greydom-status-indicator>
            <span class="m-l-5">{{ row.assessingStatus }}</span></div>
        }
      </td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.ProcessingStatus">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Stage</th>
      <td *matCellDef="let row" mat-cell class="font-small"
          style="white-space: pre"> {{getProcessingStatus(row)}} </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="transactionDisplayedColumns.length">
        <div class="row-detail-container" [@detailExpand]="row == transactionExpandedRow ? 'expanded' : 'collapsed'">
          <b>Submitted By: </b>{{row.createdBy}}<br>
          <b>Date Submitted: </b>{{convertNumberToDate(row.created) | date: dateTimeFormat}}<br>
          <b>{{row.processingStatus === ProcessingStatus.Reversed ? 'Reversed By' : 'Reviewed By'}}: </b>{{row.updatedBy}}<br>
          <b>{{row.processingStatus === ProcessingStatus.Reversed ? 'Date Reversed' : 'Date Reviewed'}}: </b>{{convertNumberToDate(row.updated) | date: dateTimeFormat}}<br>
          <b>Product: </b>{{row.productCode}}: {{row.productName}}<br>
          <b>Benefit Family: </b>{{row.familyOfBenefitList}}<br>
          <b>Chargeable Code List: </b>{{row.tariffCodeList}}<br>
          <b>Reference Number: </b>{{row.referenceNumber}}<br>
          <b>Invoice Number: </b>{{row.invoiceNumber}}<br>
          <b>Transaction Number: </b>{{row.externalTransactionNumber}}<br>
          <br>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="transactionDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: transactionDisplayedColumns;" class="row"
        [class.expanded-row]="transactionExpandedRow == row"
        (click)="transactionExpandedRow = transactionExpandedRow === row ? null : row"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>

  </table>

  <mat-paginator #transactionPaginator
                 [pageIndex]="0"
                 [length]="transactionTableControl.length"
                 [pageSize]="transactionTableControl.pageSize"
                 [pageSizeOptions]="transactionTableControl.pageSizeOptions"
                 (page)="pageChanged($event)">
  </mat-paginator>

</div>
}
